<div class="w-full p-gutter text-center">

  <h1 class="display-3 font-medium m-0">404</h1>
  <h2 class="headline m-0">Page not found.</h2>

</div>
